<template>
	<div class="detailsBox">
		<div class="top">
			<p class="text1" @click="closeFun">返回</p>
			<p class="text2">星使</p>
			<img @click="closeFun" class="close" src="./img/close.png">
		</div>
		<div class="box">
			<img class="logo" :src="dataDetail.basic.portrait">
			<div class="content">
				<div class="xingxing">
					<span class="text1">{{dataDetail.basic.realName}}</span>
					<span class="xing1" v-if="dataDetail.product.estimate == undefined">
						<img src="./img/xingxing.png">
						<img src="./img/xingxing.png">
						<img src="./img/xingxing.png">
						<img src="./img/xingxing.png">
						<img src="./img/xingxing.png">
					</span>
					<span class="xing1" v-else>
						<img src="./img/xingxing.png" v-for="item in dataDetail.product.estimate">
						<img src="./img/xingxing1.png" v-for="item in 5-dataDetail.product.estimate">
					</span>
				</div>
				<p class="text2">
					<span>{{dataDetail.uinfo.birthday || '保密'}}</span>
					<span>{{dataDetail.basic.gender == 1 ? '男' : '女'}}</span>
					<span>{{lableFun(dataDetail.product.country,dataDetail.product.typeId)}}</span>
				</p>
				<div class="text5">
					<p>星使类型：</p>
					<div>
						<p>{{lableFun(dataDetail.product.country,dataDetail.product.typeId)}}</p>
					</div>
				</div>
				<div class="text5">
					<p>星使所在地：</p>
					<div>
						<p>{{cityName}}</p>
					</div>
				</div>
				<div class="text5">
					<p>个人简介：</p>
					<div>
						<p>{{dataDetail.product.description}}</p>
						<!--<div class="imgBox">
							<img src="./img/details.jpg">
							<img src="./img/details.jpg">
							<img src="./img/details.jpg">
						</div>-->
					</div>
				</div>
				<div class="text5">
					<p>语言能力：</p>
					<div>
						<p>中文水平{{langLevel[dataDetail.product.chLevel]}} / {{englishLevel[0].langName}}水平  {{langLevel[englishLevel[0].langLevel]}}</p>
					</div>
				</div>
				<div class="text5">
					<p>联系电话：</p>
					<div>
						<p>{{dataDetail.basic.passport}}</p>
					</div>
				</div>
			</div>
			<div class="biaoqian">
				<div class="text5">
					<p>用户标签：</p>
					<div>
						<ul>
							<li v-for="item in dataDetail.tags">{{item}}</li>
						</ul>
						<p class="lineHeigth" v-if="dataDetail.tags.length == 0">暂无</p>
					</div>
				</div>
				<div class="text5">
					<p>TA的店铺服务：</p>
					<div>
						<ul class="blue">
							<li>陪同就医</li>
							<li>陪同买药</li>
							<li>接送机</li>
							<li>本地向导</li>
							<li>陪同报案</li>
							<li>陪同翻译</li>
						</ul>
					</div>
				</div>
				<p class="jiedan">已接单 {{dataDetail.product.orderCount}} 次</p>
			</div>
			<div class="tanchaung" v-if="messageShow">
				<h4>星使订单通知</h4>
				<p>星使正在参与{{messageShow.caseNo}}救援案件 订单节点：{{statusFun(messageShow.caseState)}}</p>
			</div>
		</div>
		<div class="shipin">
			<p>视屏通话</p>
		</div>
	</div>
</template>

<script>
	import { getXSDetail } from '@/views/axios/api.js';	
	import constants from "@/util/constants.js";	
	export default{
		data(){
			return {
				dataDetail:{
					basic:{},
					product:{},
					uinfo:{},
					tags:[]
				},
				label1:['旅游达人','专业律师 ','安保专家'],//国内
				label2:['普通星使','医疗星使','法律星使','旅游星使','公益星使'],//国外
				cityName:'',
				langLevel:['精通','一般','熟练'],
				englishLevel:[{"id":0,"langName":"暂无","langThumbnail":"","langLevel":2,"langCode":""}],
				messageShow:null,
			}
		},
		methods:{
			closeFun(){
				this.$emit('childClose1')
			},
			getInstituteDetail(userId,city){
				this.cityName=city
				var data={
					userId
				}
				getXSDetail(data)
				.then(res => {
					this.dataDetail=res.data.obj
					if(this.dataDetail.product.foreignLang){
						this.englishLevel=JSON.parse(this.dataDetail.product.foreignLang);
					}					
					if(res.data.obj2){
						this.messageShow=res.data.obj2
					}else{
						this.messageShow=false
					}
				})
				.catch(err =>{
					console.log(err)
				})
			},
			lableFun(num,type){
				var typeName=''
				if(type){
					if(num == '+86'){
						typeName = this.label1[type]
					}else{
						typeName = this.label2[type]
					}					
				}else{
					typeName='暂无标签'
				}

				return typeName
			},
			statusFun(id){
				return constants.pt2txt2(id).node
			}			
		}
	}
</script>

<style scoped="scoped">
.detailsBox .top{overflow: hidden;position: relative;padding: 0 20px;height: 60px;border-bottom: 1px solid #eee;}
.detailsBox .top p{line-height: 60px;}
.detailsBox .top >.text1{float: left;background: url(./img/back.png) no-repeat left center;padding-left: 30px;cursor: pointer;}
.detailsBox .top >.text2{text-align: center;font-size: 18px;}
.detailsBox .top .close{position: absolute;top: 20px;right: 20px;cursor: pointer;}
.detailsBox .box{padding: 20px 50px;overflow: hidden;}
.detailsBox .box .logo{float: left;width: 100px;height: 100px;border-radius: 50%;}
.detailsBox .box .content{float: left;margin-left: 20px;width: calc(50% - 120px);}
.detailsBox .box .biaoqian{float: left;width: calc(50% - 40px);margin-left: 40px;}
.detailsBox .xingxing{margin-top: 20px;overflow: hidden;}
.detailsBox .xingxing *{vertical-align: middle;float: left;}
.detailsBox .xingxing .text1{font-size: 18px;}
.detailsBox .xingxing .xing1{margin-top: 4px;margin-left: 10px;}
.detailsBox .xingxing img{display: inline-block;height: 16px;}

.detailsBox .text2{color: #666;line-height: 30px;font-size: 14px;}
.detailsBox .text2 span{margin-right: 10px;}
.detailsBox .text2 span:nth-child(2){border-left: 1px solid #eee;border-right: 1px solid #eee;padding: 0 10px;}
.detailsBox .text3{margin-top: 30px;}
.detailsBox .text4{margin-top: 10px;font-size: 14px;}
.detailsBox .text5{margin-top: 10px;overflow: hidden;}
.detailsBox .text5 > p{color: #333;float:left;width: 85px;font-size: 14px;}
.detailsBox .text5 > div{float:left;width: calc(100% - 100px);}
.detailsBox .text5 > div >p{color: #666;font-size: 14px;}
.shipin{overflow: hidden;padding:20px 60px;border-top: 1px solid #eee;}
.shipin p{float: right;background: url(./img/shipin.png) no-repeat left center;padding-left: 40px;background-size: 30px;line-height: 20px;cursor: pointer;}
.imgBox{margin-top: 10px;}
.imgBox img{width: 115px;height: 75px;}
.biaoqian .text5 > div{float:left;width: calc(100% - 120px);}
.biaoqian .text5 >p{line-height: 30px;width: 106px;}
.biaoqian .text5 li{color: #f3b430;border: 1px solid #f3b430;padding: 0 15px;display: inline-block;line-height: 30px;border-radius: 3px;background: #fff5e1;margin-bottom: 10px;font-size: 14px;margin-right: 5px;}
.biaoqian .text5 .blue li{color:#00abf9;border: 1px solid #00abf9;background:#f3fcff ;}
.jiedan{margin-top: 20px;color:#ff7800 ;}
.tanchaung{width: 350px;padding: 30px 20px;text-align: center;position: absolute;right: 80px;bottom: 70px;box-shadow: 0 0 10px rgba(0,0,0,0.3);background: white;}
.tanchaung h4{margin-bottom: 20px;font-size: 18px;font-weight: normal;}
.tanchaung p{color: #666;line-height: 30px;}
.lineHeigth{line-height: 30px;}
</style>


// WEBPACK FOOTER //
// src/views/map/detailsXingshi.vue